export const PageHeader = ({ eyebrow, title, subtitle }) => (
  <section className="pt-40 pb-20 md:pt-48 md:pb-24 px-5 md:px-10 border-b border-border">
    <div className="max-w-7xl mx-auto">
      {eyebrow && (
        <p data-testid="page-header-eyebrow" className="text-accent text-sm tracking-[0.2em] uppercase mb-4 font-medium">
          {eyebrow}
        </p>
      )}
      <h1 data-testid="page-header-title" className="font-heading text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.1] max-w-3xl">
        {title}
      </h1>
      {subtitle && (
        <p data-testid="page-header-subtitle" className="text-muted-foreground text-base md:text-lg mt-6 max-w-2xl leading-relaxed">
          {subtitle}
        </p>
      )}
    </div>
  </section>
);
